import { cloneDeep } from 'lodash';
import type { ILayerProps } from '@/version-types';
import { computedSegmentBaseInfo } from '../../utils/layer';

/** 归一化 Segment 绘制结果，并保留归一化前的舞台图形原点。 */
export function normalizeDrawSegmentResult(layer: ILayerProps) {
    const originLayer = cloneDeep(layer);
    computedSegmentBaseInfo(layer, originLayer);
    return layer;
}
